import React from 'react';
import { useFullscreen } from '../context/FullscreenContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';

export default function FullscreenToggle() {
  const { isFullscreen, toggleFullscreen } = useFullscreen();
  const { FiMaximize, FiMinimize } = FiIcons;

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={toggleFullscreen}
      className="p-2 rounded-lg bg-slate-100 text-slate-600 hover:bg-slate-200 hover:text-slate-900 transition-colors flex items-center justify-center"
      title={isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
    >
      <SafeIcon 
        icon={isFullscreen ? FiMinimize : FiMaximize} 
        className="w-5 h-5" 
      />
    </motion.button>
  );
}